export default __webpack_public_path__ + "static/media/one-plus-helemets-xs.65995166.jpg";